import { getOrderPage, refund } from '@/api/home/order'
import { useUserStore } from '@/store'

export enum ORDER_STATUS {
  WAIT_PAY = 0,
  WAIT_SERVICE = 1,
  SERVICEING = 2,
  REFUNDAPPLY = 3,
  REFUNDING = 4,
  REFUND = 5,
  COMPLETE = 6,
  CANCEL = 7
}

// "订单状态 订单状态 0-待支付 1-待服务 2-服务中 3-申请退款 4-退款中，5 已经退款 6 已完成,7 已经取消"

export class OrderController {
  static statusMap = new Map([
    [ORDER_STATUS.WAIT_PAY, { title: '待支付', color: 'yellow' }],
    [ORDER_STATUS.WAIT_SERVICE, { title: '待服务', color: 'blue' }],
    [ORDER_STATUS.SERVICEING, { title: '服务中', color: 'green' }],
    [ORDER_STATUS.REFUNDAPPLY, { title: '申请退款', color: 'success' }],
    [ORDER_STATUS.REFUNDING, { title: '退款中', color: 'red' }],
    [ORDER_STATUS.REFUND, { title: '已退款', color: '#f50' }],
    [ORDER_STATUS.COMPLETE, { title: '已完成', color: 'success' }],
    [ORDER_STATUS.CANCEL, { title: '已取消', color: '#f50' }]
  ])

  static typeMap = new Map([
    [0, { title: '按摩', color: '#19c865' }],
    [0, { title: '家政', color: '#19c865' }]
  ])

  static async page (params: API.Params) {
    const { data } = await getOrderPage({
      ...params,
      category: useUserStore().userInfo.agent.category
    })
    return {
      data: data.records,
      sum: data.total
    }
  }

  static async refund (data: {
    'orderId': string,
    'refundAmount': number,
    'refundReason': string
  }) {
    return await refund(data)
  }
}
